import React from "react";
import { useState, useEffect, useRef } from "react";
import AuthService from "../services/auth.service";
import NavItem from "../components/navbar/NavItem";
// import { useGoogleLogout } from "react-google-login";
import { googleLogout } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

export default function NavBar() {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [userDropDownShow, setUserDropDownShow] = useState(false);

  var ref = useRef(null);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setUserDropDownShow(false);
      }
    }

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [ref]);

  const navigate = useNavigate();

  // const { signOut, loaded } = useGoogleLogout({
  //   clientId: `612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com`,
  //   jsSrc: "https://apis.google.com/js/api.js",
  // });

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
    }
    // console.log(user);
  }, []);

  const logOut = () => {
    // signOut();
    googleLogout();
    AuthService.logout();
    setCurrentUser(undefined);
    navigate("/login");
    window.location.reload();
  };

  const handleDropDown = () => {
    setUserDropDownShow(!userDropDownShow);
  };

  return (
    <nav className="w-full flex fixed flex-row justify-between h-14 py-1 bg-black items-center shadow-lg px-5 md:px-36 z-50">
      <div className="flex flex-row items-center">
        <a href="https://310.ai/">
          <img src="/notebook/logo-2.svg" className="h-10" alt="" />
        </a>
        <NavItem href="/platform" title="Platform" a={true} />
        <NavItem href="/career" title="Career" a={true} />
        {/* {currentUser && <NavItem href="/Private" title="Private" />} */}
      </div>
      <div>
        {currentUser ? (
          <div
            className="font-light rounded-lg py-1 relative flex flex-row-reverse items-center"
            ref={ref}
          >
            <div
              className={`hidden md:block font-sans list-none mx-4 text-white font-semibold hover:text-slate-300 bg-[#2C2C2C] hover:bg-[#323232] px-2 py-1 rounded-md`}
            >
              <a href="https://310.ai/notebook">Dashboard</a>
            </div>
            <div
              className="flex items-center hover:cursor-pointer"
              onClick={handleDropDown}
            >
              <img
                src={
                  currentUser.profile_pic
                    ? currentUser.profile_pic
                    : `/notebook/avatar.png`
                }
                className="h-10 w-10 object-cover rounedd-full"
                style={{ borderRadius: "50%" }}
                alt=""
              />
            </div>
            <div
              className={`bg-[#2C2C2C] rounded-xl absolute top-12 w-52 -right-4 ${
                userDropDownShow ? "m-fadeIn" : "m-fadeOut"
              } flex flex-col items-start`}
            >
              <span className=" pl-4 font-semibold text-white text-left mt-2">
                {currentUser.name}
              </span>
              <span className="pl-4 text-white text-xs mb-4">
                {currentUser.email}
              </span>
              <span className="px-4 text-white pb-1 hover:cursor-default">
                Settings
              </span>
              <span
                onClick={logOut}
                className="px-4 w-full rounded-b-xl text-[#EB2020] pt-2 pb-3 hover:bg-[#424242] hover:cursor-pointer"
              >
                Log Out
              </span>
            </div>
          </div>
        ) : (
          <div className="flex flex-row">
            <NavItem
              href="/login"
              title="Sign In"
              className="bg-gray-300 hover:bg-gray-100 py-2 px-4 text-sm rounded-lg mx-1 cursor-pointer"
            />
          </div>
        )}
      </div>
    </nav>
  );
}
